export const list = async params => {
  return await window.$vue.$get({
    endpoint: "/leads",
    params
  })
}

export const getIndicators = async params => {
  return await window.$vue.$get({
    endpoint: `/leads/summary`,
    params
  })
}

export const get = async uuid => {
  return await window.$vue.$get({
    endpoint: `/leads/${uuid}`
  })
}

export const fetchStatesByProvider = async () => {
  return await window.$vue.$get({ endpoint: "/state/search-by-provider" })
}

export const listCities = async payload => {
  return await window.$vue.$get({ endpoint: `/city/state/${payload}` })
}

export const getTags = async () => {
  return await window.$vue.$get({ endpoint: "/leads/tags" })
}

export const create = async data => {
  return await window.$vue.$post({
    endpoint: "/leads",
    data
  })
}

export const update = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/leads/${uuid}`,
    data
  })
}

export const fetchAddressComplements = async () => {
  return await window.$vue.$get({
    endpoint: "/provider/complement"
  })
}

export const fetchAddress = async postcode => {
  return await window.$vue.$get({
    endpoint: `/city/postcode/${postcode}`,
    encrypt: false
  })
}

export const listImportationTypes = async () => {
  return await window.$vue.$get({ endpoint: `/importation-type` })
}

export const getTemplateModel = async importationTypeUuid => {
  return await window.$vue.$get({
    endpoint: `/importation/${importationTypeUuid}/template`,
    skipInterceptors: true,
    responseType: 'blob',
    headers: {
      'Accept': 'application/zip'
    },
  })
}

export const importLeads = async data => {
  return await window.$vue.$post({
    endpoint: `/importation/async`,
    data,
    headers: { "Content-Type": "multipart/form-data" }
  })
}

export const verifyImportationStatus = async params => {
  return await window.$vue.$get({
    endpoint: `/importation/${params.uuid}`,
    params
  })
}

export const getLeadHistory = async uuid => {
  return await window.$vue.$get({
    endpoint: `/leads/${uuid}/interactions`
  })
}
